// Constants.js
import Immutable        from 'immutable';

//==============================================================================
//
//  Constants singleton. Some extracted from ActionScript source.
//
//==============================================================================
class Constants {
    constructor() {
        //-------------- Symbols --------------
        Constants.DOC_TYPE_FORM   = Symbol('form');
        Constants.DOC_TYPE_REPORT = Symbol('report');
        this._app_name = "PerfectApps";
        this._app_logo = "data:image/png;base64,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";
    }

    get HAS_THUMBNAILS() { return false; } // make this true to enable thumbnail images (working at time of branch)

    // TODO Make this a key to some external resource. main.js picks it up for the dashboard version display
    get PF_VERSION()                {  return this.CURRENT_VERSION;}

    //APP CONSTANTS
    get APP_URL() { return 'https://www.perfectapps.com' }
    get APP_DOMAIN() { return 'perfectapps.com' }
    get BLOG_URL() { return 'https://www.perfectapps.com/blog/' }
    get YOUTUBE_URL() { return 'https://www.youtube.com/@perfectapps' }

    get APP_NAME() { return this._app_name }
    set APP_NAME(app_name) { this._app_name = app_name; }

    get APP_LOGO() { return this._app_logo }
    set APP_LOGO(logo) { this._app_logo = logo }
    
    get APP_SALES_EMAIL() { return 'sales@' + this.APP_DOMAIN }

    get TAWKTO_ID() { return '621950271ffac05b1d7bcf9b/1fspe26mc' }
    
    // Property IDs
    get  PROP_LEFT() {                return "left"; }
    get  PROP_TOP() {                 return "top"; }
    get  PROP_WIDTH() {               return "width"; }
    get  PROP_HEIGHT() {              return "height"; }
    get  PROP_BGCOLOR() {             return "backgroundColor"; }
    get  PROP_PADDING() {             return "padding"; }
    get  PROP_ZORDER() {              return "zOrder"; }
    get  PROP_TRANSPARENCY() {        return "transparency"; }
    get  PROP_TOOLTIP() {             return "#propTooltip"; }
    get  PROP_TABENABLED() {          return "tabEnabled"; }
    get  PROP_TABINDEX() {            return "tabIndex"; }
    get  PROP_SCREENTIP() {           return "screenTip"; }

    // Control Families

    get CONTROL_COMMON_INPUTS() { return 'common_input'; }
    get CONTROL_ADVANCED_INPUTS() { return 'advanced_input'; }
    get CONTROL_ATTACHMENTS() { return 'attachments'; }
    get CONTROL_INSTANCE() { return 'instance'; }

    // Acessibilty UI properties (for setUIAccessibilityPropery() function)
    get  ACCESS_NAME() {           return "name"; }
    get  ACCESS_DESCRIPTION() {    return "description"; }
    get  ACCESS_SILENT() {         return "silent"; }
    get  ACCESS_NOAUTOLABELING() { return "noAutoLabeling"; }
    get  ACCESS_FORCESIMPLE() {    return "forceSimple"; }

    // Misc global constants

    get STRING_EMPTY()       { return ''; }
    get STRING_DASH()       { return '-'; }
    get STRING_USCORE()       { return '_'; }
    get XATTR_PREFIX()          { return '_'; }
    get JXON_VALUE_KEY()        { return '$';}
    get STRING_HASH()       { return '#'; }
    get CANVAS_RAW_ID()     { return 'aPageSel'; }
    get GRID_CANVAS_RAW_ID()     { return 'aPageGrid'; }
    get SELECTION_EXCLUSION() { return { 'aForm': 1, 'aPageSel': 1 } }
    get MINIMUM_LAYER()      { return 4; }
    get ID_PREFIX()         { return 'PFXX'; }
    get MODEL_SILENT()      { return { silent: true }}
    get DATE_INVALID()      { return 'Invalid Date'; }
    get STRING_MATRIX_FULL_ENTRY()      { return 'all_all'; }
    get GRIDSIZE_FOR_BEHAVIOR_AND_WORKFLOW()    {return 20;}
    get MAX_BEHAVIORS_TO_DISPLAY() { return 300; }
    get PERFECTAPPS_ROOT_WITH_SIMPLE_VALUES() { return '__pa_root_with_simple_values__'; }

    get ITEM_EMPTY()          { return '< Empty >'; }
    get ITEM_UNSPECIFIED()    { return 'Unspecified'; }

    get INFINITE_SCROLL_ITEMS()   { return 50; }
    get INFINITE_SCROLL_ENABLED()   { return true; }

    // Default options for jQuery draggable
    get DEFAULT_DRAGGABLE_OPTIONS() { return { containment: 'body', scroll: false, distance: 15 } }
    get WS_ACTION_RESPONSE_STORAGE_KEY_PREFIX ()    { return 'action_response_'; }
    get WS_ACTION_REQUEST_STORAGE_KEY_PREFIX ()    { return 'action_request_'; }

    // Button img dynamic styles : see styles.css

    get NAV_BUTTON_ACTIVE()     { return 'navbutton-selected'; }
    get NAV_BUTTON_INACTIVE()   { return 'navbutton-deselected'; }

    // Menu title keys

    get KIND_LAYOUT()          { return 'L'; }
    get KIND_WORKFLOW()        { return 'W'; }
    get KIND_BEHAVIORS()       { return 'B'; }
    get KIND_REPORT()          { return 'R'; }
    get KIND_MOBILE()          { return 'M';  } 
    get KIND_THUMBLIST()          { return 'T'; }
    get KIND_DASHBOARD()          { return 'D'; }

    // JQUERY magic selectors
    get DOCUMENT()           { return 'document';}
    get BODY()               { return 'body';}
    get GHOST_CNR_ID()       { return '#ghostAppend'; }
    get FACTORY_CLASS()      { return '.factory-widget';}

    get INSTANCE_CLASS()     { return '.pf-control';}
    get INSTANCE_CORE_CLASS(){ return '.pf-control-core';}

    get LAYOUT_CLASS()       { return '.layout-frame';}
    get LAYOUT_ID()          { return '#layout-frame';}

    get BORDER_TOP_CLASS()    { return '.size-handle-top'; }
    get BORDER_LEFT_CLASS()   { return '.size-handle-left'; }
    get BORDER_RIGHT_CLASS()  { return '.size-handle-right'; }
    get BORDER_BOTTOM_CLASS() { return '.size-handle-bottom'; }

    get MENU_ANCHOR_ID()        { return '.topbar-tools'; }
    get TOOLBOX_HEADER_ID()     { return '#toolbox_container'; }
    get PROPERTIES_HEADER_ID()  { return '#properties_container'; }

    get ID_SEL ()             { return '#'; }
    get CLASS_SEL()          { return '.'; }

    get CLASS_LAYOUT()       { return '.layout'; }

    get CLASS_HAS_MENU()     { return '.has-menu'; }

    get CLASS_HIDDEN()     { return 'hiddenProp'; }

    get RCLASS_ACTIVE_TAB()   { return 'active'; }

    get PROP_SETTNGS_ID()    { return '#settings'; }
    get PROP_ATTRIBUTES_ID() { return '#attributes-section'; }
    get CONTENT_ID()         { return '#content'; }
    get LOADING()         { return '#loading'; }
    get PAGE_ID()            { return '#aPage'; }
    get PAGE_ID_HIDEN()      { return '#aPageHidden' }
    get PAGESEL()            { return 'aPageSel' }
    get PAGESEL_ID()         { return '#aPageSel' }
    get FORM_ID()            { return '#aForm'; }
    get FORM_RAW_ID()        { return 'aForm'; }
    get PAGE_ASSETS_ID()     { return '#pageAssets'; }
    get DIALOG_ID()  { return '#dialog'}
    get RESPONSIVE_CHECKBOX_ID() { return '#isResponsive'}
    get SELECT_FIELD_ID()    { return '#select-field-dialog'; }
    get SELECT_FIELD_CLASS()    { return '.select-field-dialog'; }
    get SELECT_FIELD_LIST_TOGGLE() { return 'a.field-list-toggle'; }
    get SELECT_BEHAVIOR_ITEM_FILTER() { return 'ul.control-list li.behavior-options a.behaviorLink'; }
    get SELECT_DEFAULT_LIST() { return '#selectDefaultList'; }
    get FIELD_SELECTED() { return 'field-select-modal:selected' }
    get FIELD_SELECTED_CLEAR() { return 'field-select-modal:clear' }
    get SELECT_FIELD_ITEM() { return 'a.field-select'; }
    get PROP_TAB_SUMMARY_ID() { return '#propSummary'; }
    get BEHAVIOR_TABS()         { return '#behavior-tabs'; }
    get ACTIVE_BEHAVIORS_CONTAINER()         { return '#activeBehaviors'; }
    get VIEW_STATE_MODAL() { return '#view-state-modal'}
    get VIEW_MANDATORY_MODAL() { return '#view-mandatory-modal'}
    get MIGRATE_FORM_MODAL(){return '#migrateFormModal';}
    get MODAL_DELETE_FORM_TITLE()           { return 'Delete app'; }
    get MODAL_DELETE_REPORT_TITLE()         { return 'Delete report' }
    get MODAL_DELETE_FOLDER_TITLE()         { return 'Delete folder'; }
    get MODAL_DELETE_NOT_ALLOWED_LABEL()    { return 'You do not have the necessary permissions.'; }
    get MODAL_FOLDER_NOT_EMPTY_LABEL()      { return 'This folder containts apps and cannot be deleted unless it is empty.'; }
    get MODAL_DELETE_FOLDER_LABEL()         { return 'Are you sure you want to delete this folder?'; }

    //get PROP_SECTION_ID()    {return '#property-pane-id';}
    get PROP_MAIN_ID()       { return '#propMain'; }
    get PROP_STYLE_ID()      { return '#propStyle'; }
    get PROP_STYLE_TEXT()    { return '#propStyleText'; }
    get PROP_STYLE_LABEL()    { return '#propStyleLabel'; }
    get PROP_STYLE_BAR()    { return '#propStyleBar'; }
    get PROP_STYLE_FONT()    { return '#propStyleFont'; }
    get PROP_STYLE_BUTTON_FONT()    { return '#propStyleButtonFont'; }
    get PROP_STYLE_TEXT_STYLE()    { return '#propStyleTextStyle'; }
    get PROP_STYLE_BACKGROUND()    { return '#propStyleBackground'; }
    get PROP_STYLE_BACKGROUND_COLOR()    { return '#propStyleBackgroundColor'; }
    get PROP_STYLE_BACKGROUND_GRADIENT_COLOR()    { return '#propStyleBackgroundGradientColor'; }
    get PROP_STYLE_ADVANCED_BACKGROUND_COLOR()    { return '#propStyleAdvancedBackgroundColor'; }
    get PROP_STYLE_BACKGROUND_PICTURE()    { return '#propStyleBackgroundPicture'; }
    get PROP_ACCESS_BACKGROUND_PICTURE()    { return '#propAccessBackgroundPicture'; }
    get PROP_SETTING_BACKGROUND_PICTURE()    { return '#propSettingBackgroundPicture'; }
    get PROP_STYLE_TEXT_COLOR()    { return '#propStyleTextColor'; }
    get PROP_STYLE_HEADER_BG_COLOR()    { return '#propStyleHeaderBGColor'; }
    get PROP_STYLE_BORDER()  { return '#propStyleBorder'; }
    get PROP_STYLE_ADVANCED_BORDER()  { return '#propStyleAdvancedBorder'; }
    get PROP_STYLE_SCROLLBARS() { return '#propStyleScrollbars'; }
    get PROP_STYLE_CAPTION() { return '#propStyleCaption'; }
    get PROP_STYLE_COLORS()  {return '#propStyleColors'}
    get PROP_STYLE_LINE() { return '#propStyleLine'; }
    get PROP_STYLE_MOUSE_OVER() { return '#propStyleMouseOver'; }
    get PROP_STYLE_FRAME() { return '#propStyleFrame'; }
    get PROP_STYLE_SCREEN() { return '#propStyleScreen'; }
    get PROP_STYLE_GRID() { return '#propStyleGrid'; }
    get PROP_STYLE_PAGE_TURNING() { return '#propStylePageTurning'; }
    get PROP_STYLE_SLIDER_SCALE() { return '#propStyleSliderScale' }
    get PROP_STYLE_BUTTON_BACKGROUND() { return '#propStyleButtonBackground'; }
    get PROP_STYLE_IMAGE_BACKGROUND() { return '#propStyleImageBackground'; }
    get PROP_STYLE_COLOR_THICKNESS() { return '#propStyleColorThickness'; }
    get PROP_STYLE_THEMERESET() { return '#propThemeReset'; }
    get PROP_STYLE_HEADER_TEXT() {return '#propStyleHeaderText'; }
    get PROP_STYLE_ROWS_TEXT() {return '#propStyleRowsText'; }
    get PROP_STYLE_ROWS_BACKGROUND() { return '#propStyleRowsBackground'; }

    get PROP_STYLE_GRAPH_COLOR() { return '#propStyleGraphColor'; }



    get PROP_NAV_ID()        { return '#propNav'; }
    get PROP_BHVR_ID()       { return '#behaviors-section'; }
    get PROP_ACCESS_ID()     { return '#propAccessibility'; }
    get PROP_ACCESS_SECTION() { return '#access'; }
    get PROP_ACCESS_SILENT()     { return '#propAccessSilent'; }
    get PROP_ACCESS_DESCRIPTION()     { return '#propAccessDescription'; }
    get PROP_ACCESS_AUTOFILL()     { return '#propAccessAutoFill'; }
    get PROP_ACCESS_HIDDEN()  { return '#propAccessHidden'; }
    get PROP_ACCESS_STATE()   { return '#propAccessState'; }
    get PROP_NAV_POSITION()  { return '#propNavPosition'; }
    get PROP_NAV_STYLE_POSITION()  { return '#propNavStylePosition'; }
    get PROP_NAV_TABBING()  { return '#propNavTabbing'; }
    get PROP_MAIN_NAME()     { return '#propMainName'; }
    get PROP_MAIN_PREVIEW()     { return '#propMainPreview'; }
    get PROP_MAIN_TEXT()     { return '#propMainText'; }
    get PROP_MAIN_TABLE()     { return '#propMainTable'; }
    get PROP_MAIN_TABLE2()     { return '#propMainTable2'; }
    get PROP_MAIN_CUSTOM_PARAMETERS()     { return '#propMainCustomParameters'; }
    get PROP_MAIN_HTML()     { return '#propMainHtml'; }
    get PROP_MAIN_TEXT_ALIGNMENT()     { return '#propMainTextAlignment'; }
    get PROP_MAIN_MAX_CHARS()     { return '#propMainMaxChars'; }
    get PROP_MAIN_NUMBER()     { return '#propMainNumber'; }
    get PROP_MAIN_CHECKBOX_VALUE()     { return '#propMainCheckboxValue'; }
    get PROP_MAIN_RADIO_BUTTON_VALUE()     { return '#propMainRadioButtonValue'; }
    get PROP_MAIN_TEXT_FORMAT()     { return '#propMainTextFormat'; }
    get PROP_MAIN_LENGTH()     { return '#propMainLength'; }
    get PROP_MAIN_PICTURE()  { return '#propMainPicture'; }
    get PROP_MAIN_HEADER()  { return '#propMainHeader'; }
    get PROP_MAIN_BUTTON_TYPE() { return '#propMainButtonType'; }
    get PROP_MAIN_CAPTION() { return '#propMainCaption'; }
    get PROP_MAIN_DATE_VALUE() { return '#propMainDateValue'; }
    get PROP_MAIN_CALENDAR_VALUE() { return '#propMainCalendarValue'; }
    get Z_INDEX_CALENDAR() { return 99999999999999; }
    get CSS_CALENDAR_ENABLE() { return 0.4; }
    get CSS_CALENDAR_DISABLE() { return 0.1; }
    get PROP_PRINT_FILE_NAME() { return '#propPrintFileName'; }
    
    get PROP_MAIN_AUTOCOMPLETE()     { return '#propMainAutocomplete'; }
    get PROP_MAIN_TIME_VALUE() { return '#propMainTimeValue'; }
    get PROP_MAIN_NUMERIC() { return '#propMainNumeric'; }
    get PROP_MAIN_URL() { return '#propMainUrl'; }
    get PROP_MAIN_MANDATORY() { return '#propMainMandatory'; }
    get PROP_MAIN_ENCRYPT() { return '#propMainEncrypt'; }
    get PROP_MAIN_INPUTPURPOSE() { return '#propMainInputPurpose'; }
    get PROP_MAIN_DROPDOWN() { return '#propMainDropdown'; }
    get PROP_MAIN_RANKING() { return '#propMainRanking'; }
    get PROP_MAIN_HISTORY() { return '#propMainHistory'; }
    get PROP_MAIN_DATA_HISTORY() { return '#propMainDataHistory'; }
    get PROP_MAIN_LIST_ITEM() { return '#propMainListItem'; }
    get PROP_MAIN_SUBMIT_AS_CHILD() { return '#propMainSubmitAsChild'; }
    get PROP_MAIN_AFTER_SUBMISSION() { return '#propMainAfterSubmission'; }
    get PROP_MAIN_BEHAVIOR_REDIRECT_URL() { return '#propMainBehaviorRedirectUrl'; }
    get PROP_MAIN_SHOW_SUCCESS() { return '#propMainShowSuccess'; }
    get PROP_MEDIA_SETTINGS() { return '#propMediaSettings'; }
    get PROP_SHARED_SETTINGS_LINK() { return '#propSharedSettingsLink'; }
    get DIALOG_SHARED_SETTINGS() { return '#shared-settings-dialog'; }

    get PROP_ACCESS_ID_COLUMN2() {return '#propAccessibility-col2'; }
    get PROP_TOOLTIP_COLUMN2() {return '#propTooltip-col2'; }
    get PROP_MAIN_CHART_FILTER_COLUMN2() {return '#propMainChartFilter2'}

    get DASHBOARD_LEFT_PANEL() {return '#dashboard-left-panel'; }
    get DASHBOARD_MAIN_PANEL() {return '#dashboard-main-panel'; }

    /* Workflow view constants */
    get PROP_WORKFLOW_ROLES() { return '#propWorkflowRoles'; }
    get PROP_BEHAVIOR_VIEW() { return '#prop-behavior-view'; }

    get TOOLBAR_PANE_ID()  { return '#toolbar-pane'; }
    get MOBILE_TOOLBAR_PANE_ID()  { return '#mobile_toolbar-pane'; }
    get TOOLBOX_PANE_ID()  { return '#toolbox-pane'; }
    get EDITOR_CONTENT_ID() {return '#editor-content'; }

    get THUMBPANE_ID()       { return '#thumbnail-pane'; }
    get THUMBNAIL_PANE() { return '#thumbnail-pane'; }
    get THUMBPAGES_ID()  { return '#thumb-pages'; }
    get THUMBPAGESBO_ID()  { return '#thumb-behaviorsOnly'; }
    get THUMBNAIL_ID_PREFIX()  { return 'pgref-'; }
    get THUMBPANE_SELECTED()   { return '.page-selected'; }

    get PROP_MAIN_PASSWORD() {return '#propMainPassword';}
    get PROP_MAIN_FILE_SIZE() {return '#propMainFileSize';}
    get PROP_MAIN_BUTTON_LABELS() {return '#propMainButtonLabels';}
    get PROP_MAIN_BUTTON_POSITION() {return '#propMainButtonPosition';}
    get PROP_MAIN_MASK() {return '#propMainMask';}
    get PROP_MAIN_TIMER() {return '#propMainTimer';}
    get PROP_MAIN_AUTO_START() {return '#propMainAutoStart';}
    get PROP_MAIN_TABLE_COLUMNS() {return '#propMainTableColumns';}
    get PROP_MAIN_FILE_TYPES() {return '#propMainFileTypes';}
    get PROP_MAIN_TABLE_COLUMN() {return '#propMainTableColumn';}
    get PROP_MAIN_TABLE_COLUMN_TEXT() {return '#propMainTableColumnText';}
    get PROP_MAIN_TABLE_COLUMN_DROPDOWN() { return '#propMainTableColumnDropdown'; }
    get PROP_MAIN_TABLE_MODAL() { return '#propMainTableModal'; }
    get PROP_MAIN_TABLE_ROWS() { return '#propMainTableRows'; }
    get PROP_MAIN_LABEL() {return '#propMainLabel';}
    get PROP_MAIN_SIZE() {return '#propMainFormSize';}
    get PROP_MAIN_PROGRESS() {return '#propMainProgress';}
    get PROP_MAIN_RANKING_ITEMS() { return '#propMainRankingItems'; }
    get PROP_MAIN_FORM_NAME()     { return '#propMainFormName'; }
    get PROP_MAIN_INSTANCE_NAME()     { return '#propMainInstanceName'; }
    get PROP_MAIN_PAGE() {return '#propMainPage';}
    get PROP_MAIN_SLIDER() {return '#propMainSlider';}
    get PROP_MAIN_SLIDER_CAPTIONS() {return '#propMainSliderCaptions';}
    get PROP_MAIN_FORM_INSTANCE() { return '#propMainFormInstance'; }
    get PROP_MAIN_SELECT_FORM_OR_REPORT() { return '#propMainSelectFormOrReport'; }
    get PROP_MAIN_SELECT_FORM_FIELD() { return '#propMainSelectFormField'; }
    get PROP_MAIN_SELECT_FORM_INSTANCE_ID() { return '#propMainSelectFormFieldInstanceID'; }
    get PROP_MAIN_SELECT_FORM_VALUE() { return '#propMainSelectFormFieldValue'; }
    get PROP_MAIN_MISC() { return '#propMainMisc'; }
    get PROP_MAIN_TARGET() { return '#propMainTarget'; }
    get PROP_MAIN_TABLE_CONFIG() { return '#propMainTableConfig'; }
    get PROP_MAIN_DATA_SOURCE() { return '#propMainDataSources'; }
    get PROP_MAIN_DATA_SOURCE_SINGLE() { return '#propMainDataSource'; }
    get PROP_MAIN_VALUE() { return '#propMainValue'; }

    get PROP_MAIN_FILTER_TYPE() { return '#propMainFilterType'; }
    get PROP_MAIN_FIELD() { return '#propMainField'; }
    get PROP_MAIN_FILTER_OVERRIDE() { return '#propMainFilterOverride'; }

    get PROP_MAIN_REPORT_SETTINGS() { return '#propMainReportSettings'; }
    get PROP_MAIN_FIELD_TYPE() { return '#propMainFieldType'; }
    get PROP_MAIN_FILTER() { return '#propMainFilter'; }
    get PROP_MAIN_DATA_SOURCE() { return '#propMainDataSource'; }
    get PROP_MAIN_OPERATOR() { return '#propMainOperator'; }


    get PROP_MAIN_AUTO_SUMMARY() {return '#propMainAutoSummary'; }
    get PROP_MAIN_EXIT() {return '#propMainExit'; }
    get PROP_MAIN_CONDITION() {return '#propMainCondition'; }
    get PROP_MAIN_COMMENT() {return '#propMainComment'; }
    get PROP_APPENDIX_SIZE_VIEW() {return '#propAppendixSize'; }
    get PROP_MAIN_CANCELLATION() {return '#propMainCancellation'; }
    get PROP_MAIN_FUNCTION() {return '#propMainFunction'; }
    get PROP_MAIN_PARAMETERS() {return '#propMainParameters'; }
    get PROP_MAIN_BEHAVIOR_SETTINGS() {return '#propMainBehaviorSettings'; }
    get PROP_MAIN_SELECT_TARGET_FIELD() {return '#propMainSelectTargetField'; }
    get PROP_MAIN_CONFIRMATION_SETTINGS() {return '#propMainConfirmationSettings'; }
    get PROP_MAIN_BEHAVIOR_TITLE() {return '#propMainBehaviorTitle'; }
    get PROP_MAIN_BEHAVIOR_TYPE() {return '#propMainBehaviorType'; }
    get PROP_MAIN_BEHAVIOR_SETTINGS_BOTTOM() {return '#propMainBehaviorSettingsBottom'; }
    get PROP_MAIN_BEHAVIOR_SET_FIELD_SETTINGS() {return '#propMainBehaviorSetFieldSettings'; }
    get PROP_MAIN_BEHAVIOR_SET_FIELD_VALUE_SETTINGS() {return '#propMainBehaviorSetFieldValueSettings'; }
    get PROP_MAIN_TYPE_SETTINGS() {return '#propMainTypeSettings'; }
    get PROP_CONNECTOR() { return '#propConnector'; }
    get PROP_PATH() { return '#propPath'; }
    get PROP_MAIN_TRANSACTION_SETTINGS() {return '#propMainTransactionSettings'; }

    get PROP_MAIN_RETURN_VALUE_TARGET() {return '#propMainReturnValueTarget'; }


    get PROP_MAIN_INSTANCE_NAME_VIEW() {return '#propMainInstanceNameView'; }
    get PROP_MAIN_OBJECT_STATES_VIEW() {return '#propMainObjectStatesView'; }
    get PROP_MAIN_TABLE_ACTION_VIEW() {return '#propMainTableActionView'; }

    get PROP_MAIN_TABLE_NOTIFICATION_VIEW() {return '#propModalEditTable'; }
    get PROP_MAIN_TABLE_NOTIFY_BEHAVIOR_VIEW() {return '#propNotifyTable'; }


    get PROP_MAIN_SEND() {return '#propMainSend'; }
    get PROP_MAIN_RETURN() {return '#propMainReturn'; }
    get PROP_MAIN_REDIRECT_URL() {return '#propMainRedirectURL'}
    get PROP_MAIN_SELECT_PAGE() {return '#propMainSelectPage'}
    get PROP_MAIN_SELECT_OBJECT() {return '#propMainSelectObject'}
    get PROP_MAIN_SET_PROPERTY() {return '#propSetProperty'}

    get PROP_MAIN_CHART_DATA() {return '#propMainChartData'}
    get PROP_MAIN_CHART_FIELDS() {return '#propMainChartFields'}
    get PROP_MAIN_CHART_SORT() {return '#propMainChartSort'}
    get PROP_MAIN_CHART_FILTER() {return '#propMainChartFilter'}

    get PROP_MAIN_CHART_MISC_ACCESIBILITY() {return '#propMainChartMiscAccessibility'}

    get PROP_STYLE_GAUGE_NEEDLE() {return '#propStyleGaugeNeedle'}
    get PROP_STYLE_GAUGE_BACKGROUND() {return '#propStyleGaugeBackground'}

    get PROP_ADVANCED_ID()      { return '#propAdvanced'; }
    get PROP_PAGES()      { return '#propPages'; }
    get PROP_SECTIONS()      { return '#propSections'; }
    get PROP_LOCATION()      { return '#propLocation'; }
    get PROP_APP_ACCESSIBILITY()      { return '#propAppAccessibility'; }
    get PROP_LOCKING()      { return '#propLocking'; }
    get PROP_VIEWING()      { return '#propViewing'; }
    get PROP_MULTILANGUAGE()      { return '#propMultilanguage'; }
    
    get PROP_THEME_ID()      { return '#propTheme'; }
    get PROP_THEME_PAGE()      { return '#propThemePage'; }
    get PROP_THEME_TEXTS()      { return '#propThemeTexts'; }
    get PROP_THEME_INPUTS()      { return '#propThemeInputs'; }
    get PROP_THEME_BUTTONS()      { return '#propThemeButtons'; }
    get PROP_THEME_CHECKBOXES()      { return '#propThemeCheckboxes'; }
    get PROP_THEME_GROUPS()      { return '#propThemeGroups'; }
    get PROP_THEME_TABLES()      { return '#propThemeTables'; }
    get PROP_THEME_MISC()      { return '#propThemeMisc'; }
    get PROP_THEME_ADVANCED_CSS()      { return '#propThemeAdvancedCSS'; }
    get PROP_THEME_EXPORT_IMPORT()      { return '#propThemeExportImport'; }

    get FACTORIES_ID()       { return '#factories'; }
    get UPPER_CANVAS_CLS()   { return '.upper-canvas'; }

    // Drag-drop
    get DROP_CREATE()   { return 'copy'; }
    get DROP_MOVE()     { return 'move'; }

    // IE 9 understands only 'Text' and "URL" transfer types. Our text is JSON so, we're good.
    get TYPE_TEXT()     { return 'Text'}

    // HTML or CSS attribute values
    get CLR_WHITE()     { return '#FFFFFF'; }
    get CLR_BLACK()     { return '#000000'; }
    get CLR_INVISIBLE() { return 'transparent'; }
    get DRAG_BORDER()   { return '1px dashed rgb(17,17,17)'; }
    get MAX_Z_INDEX()   { return 16777271; }
    get MIN_Z_INDEX()   { return '4'; }
    get HIDDEN_Z_ORDER(){ return '8'; }
    get OUT_OF_BOUNDS_CLASS(){ return 'outOfBounds' }

    // Canvas background colors

    get BEH_BG_CLR()        { return '#F8F8F8';}
    get BEH_GRIDLINE_CLR()  { return '#EEEEEE';}

    // Widgets . Shapes
    get SHAPE_FILL_CLR()      { return '#CCCCCC';}

    // Designer - Right Panel
    get RIGHT_PANEL_PROPERTIES_TITLE() { return ' Properties'; }

    // Events
    get EV_CLICK()      { return 'click'; }
    get EV_DBLCLICK()   { return 'dblclick'; }

    get EV_DRAG_START() { return 'dragstart'; }
    get EV_DRAG_END()   { return 'dragend'; }
    get EV_DRAGOVER()   { return 'dragover'; }
    get EV_DROP()       { return 'drop'; }

    get EV_FOCUS()      { return 'focus';}
    get EV_FOCUS_IN()   { return 'focusin';}
    get EV_FOCUS_OUT()  { return 'focusout';}

    get EV_MOUSEDOWN()  { return 'mousedown';}
    get EV_MOUSEUP()    { return 'mouseup';}
    get EV_MOUSEMOVE()  { return 'mousemove';}
    get EV_MOUSELEAVE() { return 'mouseleave';}
    get EV_MOUSEOUT()   { return 'mouseout';}
    get EV_MOUSEOVER()  { return 'mouseover';}


    get EV_KEYDOWN()    { return 'keydown'; }
    get EV_KEYUP()      { return 'keyup'; }

    get EV_PAGES_UPDATED() { return 'pagesUpdated'; }
    get EV_FORM_LOADED() { return 'formLoaded'; }

    get EV_ADD_PAGE()   { return 'addPage'; }
    get EV_PAGE_OBJECTS_UPDATED() { return 'pageObjectsUpdated'; }
    get EV_PAGE_COMMANDS_UPDATED() { return 'pageCommandsUpdated'; }
    get EV_PAGE_DELETE_CURRENT() { return 'pageDeleteCurrent'; }
    get EV_RELOAD_FAILED_NOTIFICATIONS() { return 'reloadFailedNotifications'; }
    get EV_UPDATE_BREADCRUMB() { return 'updateBreadCrumb'; }
    get EV_RENAME_PAGE() { return 'renamePage'; }
    get EV_RENAME_OBJECT_PAGE() { return 'renameObjectPage'; }
    get EV_UPDATE_BEHAVIORS_ONLY()   { return 'updateBehaviorsOnly'; }

    get EV_MOBILE_RENAME_PAGE() { return 'renameMobilePage'; }
    get EV_MOBILE_RENAME_OBJECT_PAGE() { return 'renameMobileObjectPage'; }

    get EV_CURRENT_ROLE_OR_STAGE_UPDATED(){ return 'currentRoleOrStageUpdated'; }
    get EV_ISMANDATORY_ROLE_OR_STAGE_UPDATED(){ return 'isMandatoryRoleOrStageUpdated'; }
    get EV_ROLE_OR_STAGE_UPDATED() { return 'roleOrStageUpdated'; }
    get EV_ROLE_AND_STAGE_SETTINGS_UPDATED() { return 'roleAndStageSettings'; }
    get EV_START_PAGE_SETTINGS_UPDATED() { return 'startPageSettings'; }
    get EV_UPDATE_FORM_DETAILS() { return 'updateFormDetails'; }
    get EV_UPDATE_REPORT_DETAILS() { return 'updateReportDetails'; }
    get EV_OPEN_UNDELETED_FORM_DETAILS() { return 'openUndeletedFormDetails'; }

    get EV_CURRENT_COLUMN_VIEW_UPDATED(){ return 'currentColumnViewUpdated'; }
    get EV_UPDATE_MARGIN(){return 'updateMobileMargin';}
    get EV_UPDATE_MARGIN_FROM_FORM(){return 'MarginChange';}
    get EV_RESET_COLUMN_PER_PAGE(){ return 'resetColumnPerPage'; }

    get EV_UNDELETE_REPORT() { return 'openUndeletedFormDetails'; }

    get EV_LOAD_TRIAL_STATUS() { return 'loadTrialStatus'; }

    get EV_OPEN_UNDELETED_LIST_DETAILS() { return 'openUndeletedListDetails'; }
    get EV_OPEN_UNDELETED_USER_GROUP_DETAILS() { return 'openUndeletedUserGroupDetails'; }
    get EV_OPEN_UNDELETED_USER_POSITION_DETAILS() { return 'openUndeletedUserPositionDetails'; }
    get EV_OPEN_UNDELETED_EMAIL_SERVER_DETAILS() { return 'openUndeletedEmailServerDetails'; }

    get EV_UPDATE_EMAIL_SERVER_DETAILS() { return 'updateEmailServerDetails'; }
    get EV_UPDATED_SYNCHRONIZATION_PROFILE() { return 'updatedSynchronizationProfile'; }
    get EV_VALIDATE_PULSE_ICON_EVENT() { return 'validateMobilePulseIcon'; }


   
    get EMAIL_SERVER_WARNING_TEXT() { return `
            <p>Some required email-server parameters are missing.</p>
            <p>This email-server configuration is not likely to be working.</p>
            <p>Required parameters are: server-name, server-port, and display-name,
            email-address. If selected, supply authentication username and password. 
            Additionally, if selected, supply secondary email server, and, if selected, 
            email ID destination for failure emails</p> `; }

    get EMAIL_SERVER_ERROR_TEXT() { return `
            <p>An error has occurred.</p> 
            <p>Some of the parameters are invalid.</p> `; }

    get EV_SAVE_CURRENT_FORM() { return 'SaveCurrentFormEvent'; }
    get EV_NEW_PRIVATE_FORM() { return 'newPrivateForm'; }

    get EV_OPEN_APP_DESIGNER() { return 'openAppDesigner'; }
    get EV_OPEN_REPORT_DESIGNER() { return 'openReportDesigner'; }

    get EV_DELETE_TREE_FILTER(){ return 'controlDeleted' }

    get EV_OPEN_PAGE(){ return 'openPage' }

    // PF custom Backbone events

    get CEV_NAME_CHANGE() { return 'focus:nameChange'; }
    get SWITCH_DETAIL_FORM() { return 'switchDetailForm'; }
    get SWITCH_DETAIL_REPORT() { return 'switchDetailReport'; }
    get SWITCH_DETAIL_USER() { return 'switchDetailUser'; }
    get SWITCH_DETAIL_POSITION() { return 'switchDetailPosition'; }
    get UPDATE_USER_TREEVIEW() { return 'updateUserTreeview'; }
    get UPDATE_USER_POSITION_TREEVIEW() { return 'updateUserPositionTreeview'; }
    get UPDATE_USER_GROUP_TREEVIEW() { return 'updateUserGroupTreeview'; }

    // Key codes
    get KEY_ESC()       { return 27; }
    get KEY_SHIFT()     { return 16; }

    // CSS constants
    get SELECT_ON()     { return '1px #111111 dashed'; }
    get SELECT_OFF()    { return '1px rgba(0,0,0, 0.0) dashed'; }

    // Reference URLS

    get URL_LTBR() { return this.APP_URL + '/help/index2.php?id=fd_l_m'; }
    get URL_BTBR() { return this.APP_URL + '/help/index2.php?id=fd_b_tb'; }
    get URL_WTBR() { return this.APP_URL + '/help/index2.php?id=fd_w_tb'; }

    get URL_NOTIFICATIONS() { return this.APP_URL + "/documentation/help_guide/html/hg_setting_notifications.html"; }

    // Conditional Tab Rendering
    get SETTINGS_TAB()    { return 5;}
    get STYLE_TAB()    { return 5;}
    get ACCESS_TAB()    { return 5;}
    get ATTRIBUTES_TAB()    { return 5;}
    get BEHAVIORS_TAB()    { return 5;}

    // Graphic Connections

    get BEZIER_CONTROL_COLOR() { return '#cc0000';}
    get BEZIER_CONTROL_RADIUS() { return 3;}
    get CONTROL_PT() { return 'CONTROL_PT'; }

    // Vector graphics params
    get CONNECTION_RADIUS()    { return 4;}
    get CONNECT_PT_RADIUS() { return 4; }
    get CONNECT_PT_RADIUS_WRKFLW() { return 4; }

    get CONNECTION_CLR_HOVER() { return '#FFCC66';}
    get CONNECTION_CLR_CLEAR() { return 'rgba(0,0,0,0)';}
    get CONNECTION_LINE_1()    { return '#333333';}
    get CONNECTION_LINE_2()    { return '#aaaaaa';}
    get CONNECTION_LINE_WIDTH()  { return 2; }
    get CONNECTION_LINE_TOLERANCE()  { return 6; }

    get CONNECTION_FACTORY_KEY() { return 'connection_arrow'; }

    // JSON / XML Persistence
    get ATTRIBUTE_PREFIX()      { return '_'; }
    get USE_DOUBLE_QUOTES()     { return true; }
    get EXPR_ITEM()             { return 'EXPR'; }

    // Dashboard tree views

    get DB_BORDER_COLOR()   { return '#333333';}
    get DB_BACK_COLOR()     { return '#FFFFFF';}
    get DB_FG_COLOR()       { return '#333333';}
    get DB_FG_DIM()         { return '#666666';}

    get DB_DETAIL_ID()      { return '#dbPanelTwo';}

    get DB_ICON_FOLDER()    { return 'glyphicon glyphicon-folder-close';}
    get DB_ICON_FOLDER_ACCOUNT()    { return 'glyphicon glyphicon-lock';}
    get DB_ICON_SYNCRONIZE()    { return 'glyphicon glyphicon-refresh';}
    get DB_ICON_EMPTY()     { return 'record-placeholder';}
    get DB_ICON_SETTINGS()  { return 'glyphicon glyphicon-th-list';}
    get DB_ICON_FORM()      { return 'glyphicon glyphicon-list-alt';}
    get DB_ICON_LICENSE()   { return 'glyphicon glyphicon-time';}
    get DB_ICON_USER()      { return 'glyphicon glyphicon-user';}
    get DB_ICON_RESOURCES() { return 'glyphicon glyphicon-folder-close';}
    get DB_ICON_LISTS()     { return 'glyphicon glyphicon-list-alt';}
    get DB_ICON_SERVERS()   { return 'glyphicon glyphicon-hdd';}
    get DB_ICON_NOTIFICATION()   { return 'glyphicon glyphicon-envelope';}
    get DB_ICON_CONNECTION()   { return 'glyphicon glyphicon-random';}


    // MAX-MIN Zooming constants
    get DESKTOP_MAX_WIDTH(){return 500;}
    get DESKTOP_MAX_HEIGHT(){return 400;}

    get TABLET_MAX_WIDTH(){return 400;}
    get TABLET_MAX_HEIGHT(){return 500;}

    get PHONE_MAX_WIDTH(){return 300;}
    get PHONE_MAX_HEIGHT(){return 500;}

    get SCALE_FACTOR_ZOOM_IN(){return 1.3;}
    get SCALE_FACTOR_ZOOM_OUT(){return 1/1.3;}
    get SCALE_FIT_TO_WINDOW_OUT(){return 0.80;}
    get SCALE_FIT_TO_WINDOW_IN(){return 1.133;}
    get ACCUM_BRACKETED_BORDER_WIDTH(){return 4;}

    get DEFAULT_GROUP_ID(){ return '-9223372036854775808';}
    get DEFAULT_FORM_NAME() { return 'New App'; }

    get FORMS_PRIVATE_GROUP_TYPE(){return "1";}
    get FORMS_SHARED_GROUP_TYPE(){return "2";}
    get FORMS_PRIVATE_SECTION(){return "PrivateForms";}
    get FORMS_SHARED_SECTION(){return "SharedForms";}

    get DEFAULT_FORM_FOLDER_NAME(){return "New Folder";}

    get REPORTS_PRIVATE_SECTION(){return "PrivateReports";}
    get REPORTS_SHARED_SECTION(){return "SharedReports";}


    get FORMS_VIEW_GROUP_TYPE(){return "A";}
    get FORMS_LIBRARY_GROUP_TYPE(){return "0";}

    get REPORTS_PRIVATE_GROUP_TYPE(){return "3";}
    get REPORTS_SHARED_GROUP_TYPE(){return "4";}
    get REPORTS_VIEW_GROUP_TYPE(){return "6";}
    get DEFAULT_REPORT_NAME() { return 'New Report'; }
    get FAVORITE_REPORT_OBJTYPE(){ return "2"; }

    get NOTIFICATION_ATTENTION_NEEDED_GROUP_TYPE(){return "7";}
    get NOTIFICATION_NO_ATTENTION_NEEDED_GROUP_TYPE(){return "8";}
    get NOTIFICATION_VIEW_GROUP_TYPE(){return "9";}

    get ATTENTION_NEEDED_SECTION(){return "AttentionNeeded";}
    get NO_ATTENTION_NEEDED_SECTION(){return "NoAttentionNeeded";}

    get ACCOUNT_FOLDER_GROUP_TYPE(){return "10";}
    get PERSONAL_FOLDER_GROUP_TYPE(){return "11";}
    get ACCOUNT_FOLDER_REPORT_GROUP_TYPE(){return "12";}
    get PERSONAL_FOLDER_REPORT_GROUP_TYPE(){return "13";}
    get DATABASES_GROUP_TYPE(){return "1";}
    get DIRECTORY_GROUP_TYPE(){return "2";}
    get WEB_GROUP_TYPE(){return "3";}
    get FORMS_GROUP_TYPE(){return "4";}
    get TEXT_GROUP_TYPE(){return "7";}
    get GOOGLE_GROUP_TYPE(){return "9";}
    get REST_GROUP_TYPE(){return "11";}
    get VECTORDB_GROUP_TYPE(){return "12";}
    get GOOGLE_GROUP_TYPE_DETAIL_VIEW(){return "8";}
    get GOOGLE_ACTION_DETAIL_VIEW(){return "10";}
    get CONNECTIONS_DEFAULT_PURPOSE(){return "0";}
    get DATABASE_ACTION_TYPE(){return "11";}
    get DATABASE_ACTION_XML(){return "H4sIAAAAAAAA/3jaJY5NCsIwEIWvMswFStKYNtAWXLpxUb1AfqYQqFMxqeLtHezu8fG9xxvOseaNIacREdg/aMQrfeDACPX7FKIUghfyllxfOyHEjZn+zkWaffB6scoG1xpD9uTapTe+c51xSeuUcBpuxKmZhpkiyQykXGrmWGcq+1rLiItfC6EYdx9WKhKa48P0A46ONHQvWsicowAAAA==";}
    

    get SETTINGS_USERS_GROUP_TYPE(){return "70";}
    get SETTINGS_RESOURCES_GROUP_TYPE(){return "71";}
    get SETTINGS_ARCHIVE_GROUP_TYPE(){return "72";}
    get SETTINGS_PERSONAL_GROUP_TYPE(){return "73";}
    get IMPORT_LIBRARY_SUCCESS(){return "IMPORT_LIBRARY_SUCCESS";}

    get SETTINGS_RESOURCES_LISTS(){return "70"}
    get SETTINGS_RESOURCES_EMAIL_SERVERS(){return "71"}

    get DEFAULT_REPORT_ID (){return "0";}

    get NOTIFICATIONS_ATTENTION_NEEDED_TYPE(){return "7"}

    get NOTIFICATIONS_NO_ATTENTION_NEEDED_TYPE(){return "8"}

    get FORMS_PUBLISHED_GROUP_TYPE(){return "9";}
    get EVENLY_ACROSS(){return "left";}
    get EVENLY_DOWN(){return "top";}

    get LAYER_UP(){return "layerUp";}
    get LAYER_DOWN(){return "layerDown";}

    get ALIGN_VERTICAL(){return "left";}
    get ALIGN_HORIZONTAL(){return "top";}

    // Alignment props
    get PROP_GRID_WIDTH()  { return 'gridWidth'; }
    get PROP_GRID_HEIGHT() { return 'gridHeight'; }

    // Fabric stuff
    get REDRAW_OFFSET() { return 4.5; }

    // Connections
    get LINE_TYPE_STRAIGHT() { return 'straight'; }
    get LINE_TYPE_CURVED()   { return 'bezier'; }

    get A_END() { return 'A end';} // Blunt end of connector line
    get B_END() { return 'B end';} // Arrow end of connector line.

    // Connection and Transaction behavior default values.
    get BEHAVIOR_CONNECTIONS_FORM_ID() { return '16239'; }
    get BEHAVIOR_CONNECTIONS_TYPE() { return '-1'; }
    get BEHAVIOR_CONNECTIONS_PURPOSE() { return '1'; }

    // Connection Settings default values.
    get SETTINGS_CONNECTIONS_FORM_ID() { return '-9223372036854775808'; }
    get DEFAULT_TOKEN() { return '-9223372036854775808'; }
    get SETTINGS_CONNECTIONS_TYPE() { return '-1'; }
    get SETTINGS_CONNECTIONS_PURPOSE() { return '0'; }
    get SETTINGS_PARAMETERS_PURPOSE() { return '3'; }

    //SSO
    get DEFAULT_VALUE() { return '-9223372036854775808'; }

    // Connection dot numbers from PF. 1 is south; 0 is east; 3 is north; 2 is west;
    get BEH_DOT_N() { return 3; }
    get BEH_DOT_E() { return 0; }
    get BEH_DOT_S() { return 1; }
    get BEH_DOT_W() { return 2; }

    // Server constants
    get TIMEOUT_SECONDS() { return 30; }
    get SESSION_TIMEOUT_MS() { return 120000; }
    get SESSION_TIMEOUT_RETRY_MS() { return 30000; }

    // Attention Levels
    get NONE_ATTENTION_LEVEL() { return '0'; }
    get NORMAL_ATTENTION_LEVEL() { return '1'; }
    get NORMAL_PLUS_ATTENTION_LEVEL() { return '1+'; }
    get HIGH_ATTENTION_LEVEL() { return '2'; }
    get HIGH_PLUS_ATTENTION_LEVEL() { return '2+'; }
    get URGENT_ATTENTION_LEVEL() { return '3'; }
    get URGENT_PLUS_ATTENTION_LEVEL() { return '3+'; }
    get VERY_URGENT_ATTENTION_LEVEL() { return '4'; }
    get VERY_URGENT_PLUS_ATTENTION_LEVEL() { return '4+'; }
    get EXTREMELY_URGENT_ATTENTION_LEVEL() { return '5'; }


    get ATTN_LEVELS() { return ['No attention needed', 'Normal attention needed','High attention needed',
        'Urgent attention needed', 'Very urgent attention needed', 'Extremely urgent attention needed']; }
    get NOTIFY_TIMES() { return ['Now', 'On a specific date', 'After a fixed period',
        'After a period taken from a field', 'On a date taken from a field', 'On a date taken from a formula',
        'Until the next stage is reached every']; }
    get CANCEL_TYPES() { return ["Other", "The instance is opened", "The instance is submitted",
        "The instance's stage has changed", "This condition is met"]; }


    //HELP LINKS
    get  HELP_URL() { return this.APP_URL + "/help/index2.php"; }
    get  HELP_VIDEOS() { return this.APP_URL + "/help/video/video.php"; }
    get  HELP_DOCUMENTATION() { return this.APP_URL + "/Documentation/help_guide/html/"; }

    get POLICIES() { return this.APP_URL  + "/policies/"; }
    get PRIVACY_POLICY() { return this.APP_URL + "/privacy-policy"; }
    get RELEASE_NOTES() { return this.APP_URL + "/release_notes.php"; }
    
    get  HELP_GENERAL_URL() { return this.HELP_URL + "?id=fd_c_sf"; }
    get  HELP_LAYOUT_URL() { return this.HELP_URL + "?id=fd_l_tb"; }
    get  HELP_LAYOUT_TOOLBAR_URL() { return this.HELP_URL + "?id=fd_l_m"; }
    get  HELP_BEHAVIOR_URL() { return this.HELP_URL + "?id=fd_b_tb"; }
    get  HELP_WORKFLOW_URL() { return this.HELP_URL + "?id=fd_w_tb"; }
    get  HELP_QUICK_START() {  return this.HELP_URL + "?id=sdb_g"; }
    get  HELP_ADMIN_PF() {  return this.HELP_URL + "?id=sdb_h"; }
    get  HELP_GETTING_STARTED() {  return this.HELP_DOCUMENTATION + "hg_getting_started_page.html"; }
    
    //CONNECTIONS
    get  HELP_CONNECTIONS_URL() { return this.HELP_URL + "?id=cdb_a"; }
    get  HELP_CONNS_INTEGRATION() {  return this.HELP_URL + "?id=cdb_b"; }
    get  HELP_CONNS() {  return this.HELP_URL + "?id=cdb_c"; }
    get  HELP_CONNS_ACTIONS() {  return this.HELP_URL + "?id=cdb_d"; }

    //FORMS
    get  HELP_FORMS_URL() { return this.HELP_URL + "?id=fdb_a"; }
    get  HELP_EDIT_FORMS() {  return this.HELP_URL + "?id=fdb_b"; }
    get  HELP_VIEW_FORMS() {  return this.HELP_URL + "?id=fdb_c"; }

    //REPORTS
    get  HELP_REPORT_URL() { return this.HELP_URL + "?id=rd_c_m"; }
    get  HELP_REPORTS_URL() { return this.HELP_URL + "?id=rdb_a"; }
    get  HELP_EDIT_REPORT() {  return this.HELP_URL + "?id=rdb_b"; }
    get  HELP_VIEW_REPORT() {  return this.HELP_URL + "?id=rdb_c"; }
    get  HELP_REPORT_TOOLBAR_URL() { return this.HELP_URL + "?id=rd_l_tb"; }
    get  HELP_REPORT_BEHAVIOR_URL() { return this.HELP_URL + "?id=rd_b_tb"; }

    //ACCOUNT
    get  HELP_URL_ACCOUNT_SETTINGS() { return this.HELP_URL + "?id=sdb_a"; }
    get  HELP_ACC_SETTINGS() {  return this.HELP_URL + "?id=sdb_b"; }
    get  HELP_ADMIN_USERS() {  return this.HELP_URL + "?id=sdb_c"; }
    get  HELP_ADD_ACCOUNT() {  return this.HELP_URL + "?id=sdb_d"; }
    get  HELP_SETTINGS() {  return this.HELP_URL + "?id=sdb_e"; }
    get  HELP_LICENSE_INFO() {  return this.HELP_URL + "?id=sdb_f"; }
    get  HELP_SYNCHRONIZING() {  return this.HELP_URL + "?id=sdb_i"; }
    get  HELP_ADD_LIST() {  return this.HELP_URL + "?id=sdb_j"; }
    get  HELP_EMAIL_SERVER() { return this.HELP_URL + "?id=sdb_k"; }
    get  HELP_PERSONAL_SETTINGS() { return this.HELP_URL + "?id=sdb_l"; }

    //NOTIFICATIONS
    get  HELP_NOTIFICATIONS_URL() { return this.HELP_URL + "?id=ndb_a"; }
    

    //VIDEOS
    get  QUICK_START_URL() { return this.HELP_URL + "?id=hc_qs"; }
    get  TRAINING_VIDEOS_URL() { return this.HELP_URL + "?id=hc_vt"; }
    get  FORM_DESIGNER_VIDEO_URL() { return this.HELP_VIDEOS + "?id=e_hc_qt_f&b=0&f=1"; }
    get  HELP_CENTER_DASHBOARD_VID ( ) { return "e_hc_qt_db"; }
    get  HELP_CENTER_FORMS_VID ( ) { return ''; }// this is empty because exists a validation where if this is empty return the form video
    get  HELP_CENTER_REPORTS_VID ( ) { return 'e_hc_qt_r'; }
    get  HELP_CENTER_WIZARD_VID ( ) { return 'mtv1'; }

    // Start page constants
    get START_PAGE_OPTIONS() {
        return [
            {value: 'default', label: 'Default'},
            {value: 'last', label: 'Last shown'}
        ]
    }

    // Stage and Role Constants
    get STATE_OPTIONS(){
        return [
            {value: 'default', label:'Default'},
            {value: 'normal', label:'Normal'},
            {value: 'readonly', label:'Read-Only'},
            {value: 'disabled', label:'Disabled'},
            {value: 'hidden', label:'Hidden'}
        ];
    }

    get REDUCED_STATE_OPTIONS(){
        return [
            {value: 'default', label:'Default'},
            {value: 'normal', label:'Normal'},
            {value: 'hidden', label:'Hidden'}
        ];
    }

    get REDUCED_STATE_OPTIONS2(){
        return [
            {value: 'default', label:'Default'},
            {value: 'normal', label:'Normal'},
            {value: 'disabled', label:'Disabled'},
            {value: 'hidden', label:'Hidden'}
        ];
    }

    get FLASH_STATE_OPTIONS(){
        return [
            {value: 'normal',   label:'Normal'},
            {value: 'readonly', label:'Read-Only'},
            {value: 'disabled', label:'Disabled'}
        ];
    }

    get MANDATORY_OPTIONS(){
        return [{value:"yes", label: "Yes" }, {value:"no", label: "No" }];
    }

    get DOC_TYPE_FORM()     { return  Constants.DOC_TYPE_FORM; }
    get DOC_TYPE_REPORT()   { return  Constants.DOC_TYPE_REPORT; }
    get GROUP_KEYS()        {return Immutable.Set(['control_group', 'control_radio_button_group', 'control_checkbox_group']); }
    // PF-8700 Added keys for allowed transparent inputs
    get TRANSPARENT_CONTROL_KEYS()        {return Immutable.Set(['control_checkbox', 'control_radio_button']); }
    get WORKFLOW_FACTORY_KEYS() {return Immutable.Set(['workflow_stage', 'workflow_comment'])}
    get CONTROL_CAPTION_VALUE_KEYS()        {return Immutable.Set(['control_group', 'control_list', 'control_drop_down', 'control_radio_button']); }
    get CONTROL_MIN_WIDTH() { return '22'; }
    get CONTROL_MIN_HEIGHT() { return '16'; }

    get GROUP_HEADER_MAX_CHAR() { return 99; }

    get CONNECTIONS_DEFAULT_OPTION(){return 'Please select one connection';}
    get ACTIONS_DEFAULT_OPTION(){return 'Please select one action';}
    get PARAMETERS_DEFAULT_OPTION(){return 'Please select one parameter';}
    get EMPTY_CONNECTIONS_OPTION(){return 'No connections available';}
    get EMPTY_ACTIONS_OPTION(){return 'No actions available';}
    get EMPTY_PARAMETERS_OPTION(){return 'No parameters available';}
    get EMPTY_SEARCH() { return 'No items match your search.'; }
    get EV_UPDATED_ACCOUNT_SETTINGS(){return 'updatedAccountSettings';}
    get EV_REFRESH_LICENSE_DETAILS(){return 'refreshLicenseDetails';}
    get EV_DELETE_EMAIL_SERVER(){return 'deleteEmailServer';}
    get EV_DELETE_USER(){return 'deletingUser';}
    get EV_DELETE_USER_GROUP(){return 'deletingUserGroup';}
    get EV_DELETE_USER_POSITION(){return 'deletingUserGroup';}
    get EV_DELETE_CUSTOM_LIST(){return 'deleteCustomList';}
    get EV_UPDATE_PERSONAL_DETAILS(){return 'updatePersonalDetails';}
    get EV_UPDATE_CUSTOM_LIST_DETAILS(){return 'updateCustomListDetails';}
    get EV_UPDATE_EXPAND_CUSTOM_LIST_DETAILS(){return 'updateExpandCustomListDetails';}
    get EV_UPDATE_CONNECTION_DETAILS(){return 'updateConnectionDetails';}
    get EV_UPDATE_ACTION_DETAILS(){return 'updateActionDetails';}
    get EV_DELETE_CONNECTION(){return 'deleteConnection';}
    get EV_DELETE_ACTION(){return 'deleteAction';}
    get EV_ADD_ACTION(){return 'addAction';}
    get EV_SHOW_NOTIFICATION_DETAILS(){return 'showNotificationDetails';}
    get EV_SHOW_ATTENTION_NOTIFICATION_DASHBOARD(){return 'showAttentionNotificationDashboard';}
    get EV_REFRESH_EDIT_FORMS_DASHBOARD(){return 'refreshEditFormsDashboard';}
    get EV_REFRESH_PRIVATE_NODES(){return 'refreshPrivateNodes';}
    get EV_REFRESH_FOLDER(){return 'refreshFolder';}
    get EV_REFRESH_FORM(){return 'refreshForm';}
    get EV_REFRESH_FORM_INSTANCES(){return 'refreshFormInstances';}
    get EV_REFRESH_FORM_INSTANCE_DETAILS(){return 'refreshFormInstanceDetail'}
    get EV_REFRESH_VIEW_FORMS(){return 'refreshViewForms';}
    get EV_REFRESH_LIBRARY_FORMS(){return 'refreshLibraryForms';}
    get EV_REFRESH_LIBRARY_FOLDER(){return 'refreshLibraryFolder';}
    get EV_REFRESH_LIBRARY_DETAILS(){return 'refreshLibraryDetails';}
    get EV_REFRESH_PRIVATE_REPORT_NODES(){return 'refreshPrivateReportNodes';}
    get EV_REFRESH_EDIT_REPORT_FOLDER(){return 'refreshEditReportFolder';}
    get EV_REFRESH_VIEW_REPORTS(){return 'refreshViewReports';}
    get EV_REFRESH_VIEW_REPORT_FOLDER(){return 'refreshViewReportFolder';}
    get EV_REFRESH_ATTENTION_NEEDED_NOTIFICATIONS_DASHBOARD_AND_NODES(){return 'refreshAttentionNeededNotifications';}
    get EV_REFRESH_NO_ATTENTION_NEEDED_NOTIFICATIONS_DASHBOARD_AND_NODES(){return 'refreshNoAttentionNeededNotifications';}
    get EV_REFRESH_FAILED_NOTIFICATIONS_DASHBOARD(){return 'refreshFailedNotifications';}
    get EV_REFRESH_CONNECTION_NODES(){return 'refreshConnectionNodes';}
    get EV_REFRESH_CONNECTION_ACTIONS(){return 'refreshConnectionActions';}
    get EV_REFRESH_ACTION_DETAILS(){return 'refreshActionDetails';}
    get EV_REFRESH_USER_NODES_AND_DETAIL(){return 'refreshUserNodesAndDetail';}
    get EV_REFRESH_USER_GROUP_NODES_AND_DETAIL(){return 'refreshUserGroupNodesAndDetail';}
    get EV_REFRESH_POSITION_NODES_AND_DETAIL(){return 'refreshPositionNodesAndDetail';}
    get EV_REFRESH_LIST_NODES(){return 'refreshListNodes';}
    get EV_REFRESH_EMAIL_SERVER_NODES(){return 'refreshEmailServerNodes';}
    get EV_REFRESH_ACCOUNT_DETAILS(){return 'refreshAccountDetails';}
    get EV_REFRESH_LICENSE_DETAILS(){return 'refreshLicenseDetails';}
    get EV_REFRESH_USER_DETAILS(){return 'refreshUserDetails';}
    get EV_REFRESH_USER_GROUP_DETAILS(){return 'refreshUserGroupDetails';}
    get EV_REFRESH_POSITION_DETAILS(){return 'refreshPositionDetails';}
    get EV_REFRESH_SYNCHRONIZE_DETAILS(){return 'refreshSynchronizeDetails';}
    get EV_REFRESH_LIST_DETAILS(){return 'refreshListDetails';}
    get EV_REFRESH_EMAIL_SERVER_DETAILS(){return 'refreshEmailServerDetails';}
    get EV_REFRESH_CONNECTION_DETAILS(){return 'refreshConnectionDetails';}
    get EV_REFRESH_ARCHIVED_INSTANCE_DETAILS(){return 'refreshArchivedInstanceDetails';}
    get EV_REFRESH_NEW_ARCHIVE_DETAILS(){return 'refreshNewArchiveDetails';}
    get EV_REFRESH_REPORTS_MAIN_VIEW_DETAILS(){return 'refreshReportsMainViewDetails';}
    get EV_REFRESH_FORMS_MAIN_VIEW_DETAILS(){return 'refreshFormsMainViewDetails';}
    get EV_REFRESH_NOTIFICATIONS_MAIN_VIEW_DETAILS(){return 'refreshNotificationsMainViewDetails';}
    get EV_OPEN_UNDELETED_USER_DETAILS(){return 'refreshUndeletedUserDetails';}
    get EV_REFRESH_REMOTE_DATA_FILTER(){return 'refreshRemoteDataForSearchFilter';}
    get EV_SELECT_OBJECT(){return 'selectObject';}
    get EV_RESTORE_FILTER_RESULT(){ return 'restoreFilterResult'; }

    /* Form Treeview Selectors */
    get EDIT_FORMS_ROOT_SELECTOR(){return "div[data-nodetype='sectionEditForms'] + div #well_2 > UL"}
    get EDIT_FORMS_CONTAINER(){return "#well_2"}
    get EDIT_FORMS_SECTION_CONTAINER(){return "#well_1"}
    get SHARED_FORMS_CONTAINER(){return "#well_3"}
    get VIEW_FORMS_CONTAINER(){return "#well_4"}
    get LIBRARY_FORMS_CONTAINER(){return "#well_5"}
    get NO_ITEMS_CONTAINER(){return "#well0"}


    get ACCOUNT_SECTION_CONTAINER(){return "#well_1"}
    get RESOURCES_SECTION_CONTAINER(){return "#well_3"}
    get USERS_SECTION_CONTAINER(){return "#well_2"}
    get USERS_GROUP_CONTAINER(){return "#wellusersGroup"}
    get USERS_GROUP_GROUP_CONTAINER(){return "#welluserGroupsGroup"}
    get EMAIL_SERVERS_GROUP_CONTAINER(){return "#wellEmailsGroup"}
    get SERVICE_URL_GROUP_CONTAINER(){return "#wellServiceURL"}
    get LISTS_GROUP_CONTAINER(){return "#wellListsGroup"}
    get USERS_POSITION_GROUP_CONTAINER(){return "#wellpositionsGroup"}
    get USER_GROUP_DELETED(){return "userGroupDeleted"}
    get USER_POSITION_DELETED(){return "userPositionDeleted"}

    get CONNECTION_DATABASES_CONTAINER(){return "#well_1"}
    get CONNECTION_DIRECTORY_SERVICES_CONTAINER(){return "#well_2"}
    get CONNECTION_WEB_SERVICES_CONTAINER(){return "#well_3"}
    get CONNECTION_FORMS_CONTAINER(){return "#well_5"}
    get CONNECTION_GOOGLE_SPREADSHEETS_CONTAINER(){return "#well_6"}
    get CONNECTION_TEXT_CONTAINER(){return "#well_7"}
    get CONNECTION_REST_CONTAINER(){return "#well_4"}
    get CONNECTION_VECTORDB_CONTAINER(){return "#well_8"}

    get CONNECTION_CONTAINERS(){ return ["#well_1","#well_2","#well_3","#well_5","","","#well_7","","#well_6","","#well_4"]}


    get CONNECTION_DATABASES_SECTION() { return 'databases' }
    get CONNECTION_DIRECTORY_SECTION() { return 'directory' }
    get CONNECTION_WEB_SECTION() { return 'web' }
    get CONNECTION_REST_SECTION() { return 'rest' }
    get CONNECTION_FORMS_SECTION() { return 'forms' }
    get CONNECTION_GOOGLE_SECTION() { return 'google' }
    get CONNECTION_TEXT_SECTION() { return 'text' }
    get CONNECTION_VECTORDB_SECTION() { return 'vectordb' }

    get CONNECTION_SELECT_SEND_CONTAINER(){return "#propSendSelect"}
    get CONNECTION_SELECT_RETURN_CONTAINER(){return "#propReturnSelect"}
    get CONNECTION_UPDATE_SEND_CONTAINER(){return "#propSendUpdate"}
    get CONNECTION_UPDATE_RETURN_CONTAINER(){return "#propReturnUpdate"}
    get CONNECTION_INSERT_SEND_CONTAINER(){return "#propSendInsert"}
    get CONNECTION_DELETE_SEND_CONTAINER(){return "#propSendDelete"}
    get CONNECTION_STORE_PROCEDURE_SEND_CONTAINER(){return "#propSendStore"}
    get CONNECTION_STORE_PROCEDURE_RETURN_CONTAINER(){return "#propReturnStore"}
    get CONNECTION_STR_SEND_CONTAINER(){return "#propSendStr"}
    get CONNECTION_STR_RETURN_CONTAINER(){return "#propReturnStr"}
    get CONNECTION_XML_SEND_CONTAINER(){return "#propSendXML"}
    get CONNECTION_XML_RETURN_CONTAINER(){return "#propReturnXML"}
    get CONNECTION_REST_SEND_CONTAINER(){return "#propSendREST"}
    get CONNECTION_REST_RETURN_CONTAINER(){return "#propReturnREST"}
    get CONNECTION_STORE_PROCEDURE_RETURN_CONTAINER(){return "#propReturnStore"}
    get TEST_ACTION_CONTAINER(){return "#propTestActionTable"}
    get TEST_ACTION_LOG_GRID(){return "#responseLogGrid"}
    get GRID_RESULTS_CONTAINER(){return "#propResultsTable"}
    get GRID_RESULTS_CONTAINER_DIV(){return "#divPropResultsTable"}

    get CONNECTION_DATABASE_SELECT(){return "11"}
    get CONNECTION_DATABASE_UPDATE(){return "12"}
    get CONNECTION_DATABASE_INSERT(){return "10"}
    get CONNECTION_DATABASE_DELETE(){return "14"}
    get CONNECTION_DATABASE_STORE_PROCEDURE(){return "13"}

    get CONNECTION_DIRECTORY_SERVICES_SELECT(){return "21"}
    get CONNECTION_DIRECTORY_SERVICES_UPDATE(){return "22"}
    get CONNECTION_DIRECTORY_SERVICES_INSERT(){return "20"}
    get CONNECTION_DIRECTORY_SERVICES_DELETE(){return "23"}

    get CONNECTION_WEB_SERVICES_STRING_RESULT(){return "30"}
    get CONNECTION_WEB_SERVICES_XML_RESULT(){return "31"}

    get CONNECTION_FORMS_READ(){return "40"}
    get CONNECTION_FORMS_INSERT(){return "41"}
    get CONNECTION_FORMS_UPDATE() { return "42" }
    get CONNECTION_FORMS_DELETE(){return "43"}

    get CONNECTION_GOOGLE_READ(){return "81"}
    get CONNECTION_GOOGLE_INSERT(){return "82"}
    get CONNECTION_GOOGLE_UPDATE(){return "83"}
    get CONNECTION_GOOGLE_DELETE(){return "84"}
    get CONNECTION_GOOGLE_SELECT(){return "85"}

    get CONNECTION_TEXT_INSERT(){return "70"}
    get CONNECTION_TEXT_SELECT(){return "71"}
    get CONNECTION_TEXT_UPDATE(){return "72"}
    get CONNECTION_TEXT_DELETE(){return "73"}

    get CONNECTION_REST_GET(){return "110"}
    get CONNECTION_REST_POST(){return "111"}
    get CONNECTION_REST_PUT() { return "112" }
    get CONNECTION_REST_DELETE(){return "113"}

    get CONNECTION_VECTORDB_QUERY(){return "120"}
    get CONNECTION_VECTORDB_SYNC(){return "121"}
    get CONNECTION_VECTORDB_UPSERT(){return "122"}
    get CONNECTION_VECTORDB_DELETE(){return "123"}

    get CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_ID() { return "form_instance_guid_param"; }
    get CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_NAME() { return "Form Instance ID"; }
    get CONNECTION_FORM_INSTANCE_NOT_AVAILABLE_ERROR_CODE() { return "44"; }
    get CONNECTION_FORM_INSTANCE_NOT_AVAILABLE_ERROR_MESSAGE() { return "The app-instance is no longer available."; }

    get CONNECTION_DOT_PLACEHOLDER() { return "\\."; }

    get GETTING_STARTED_SETTINGS_XML(){return "H4sIAAAAAAAA/3jaXVJda4NAEPwr4Z4Pep9qoBaa2DaBmoacrc9n1CRgElALpb++u3eapAFF9mZnbmbXR1P1/eG06yZVafarr5j07XdFoFrbpMltTGrbdHBwtKtz3vGY8CmVjNFQU8Wwb3WOScQUDdhQLvpjc6FVZVaYbVbMYyKEcrrF3EIVYeVFhRPlahClET6e+m49Fa862vn5tU52MUFs1npEO1GzX0DBpcYi6WKiAkbV1KmYHg0yOtHMqXx2OTRwaMBXu/u8/vLkzYAHDoTgYsVDCq4DRFxQddcgrw3ilo7+THodbVbk0MmnHsnr9GbKWQuYZG446c/yhJIDp3aJ2Tg2ibHQP3cfPJ61aYnD9MJv7aG8WYTZbqp/C4UOM5rykpCQC03DiAoFG9GSahWO6ThaGTKNsbZ3/4jpX0q/nzVmlEK701/Q1TCPMHC0jwIhRqXkWD43Q6rELg64X1gUxWU9PP0Bvdyxj6GrJIifAgAA"}

    get MOBILE_VIEW_PHONE(){return "1";}
    get MOBILE_VIEW_TABLET(){return "2";}
    get MOBILE_DEVICE_PHONE() {return "devicePhone";}
    get MOBILE_DEVICE_TABLET() {return "deviceTablet";}
    get MOBILE_DEVICE_DESKTOP() {return "deviceDesktop";}

    get MOBILE_ICON_ENABLED_CLASS() {return "mobile-icon-enabled";}

    get FORM_FIELD_COLUMN() {return 5;}

    get OWNER_ARCHIVED_PERMISSION() {return "ownerArchived";}
    get OWNER_INSTANCES_PERMISSION() {return "ownerInstances";}
    get GRID_LIST_FORMS_CONTAINER() {return "#propListFormsTable";}
    get GRID_LIST_FORMS_INSTANCES_CONTAINER() {return "#propListFormInstancesTable";}
    get UNARCHIVE_INSTANCE() {return 0;}
    get ARCHIVE_INSTANCE() {return 1;}
    get DELETE_INSTANCE() {return 2;}

    get DEFAULT_TOOLBOX_GROUP() { return 'common';}

    get PROP_SETTINGS() {return 'settings';}
    get PROP_STYLE() {return 'style';}
    get PROP_ACCESS() {return 'access';}

    get DEFAULT_REPORT_NAME() {return "New Report";}
    get DASHBOARD_LOADED() {return "Dashboard loaded";}
    get DASHBOARD_REPORTS_LOADED() {return "DashboardReportsLoaded";}
    get DEFAULT_FILE_SIZE_MB(){return 2;}
    get DEFAULT_FILE_SIZE_BYTES(){return 2;}
    get CANVAS_Z_INDEX(){return -99999;}

    get LINE_MODEL_OPTIONS() {return {
            fill:          this.CONNECTION_LINE_1,
            stroke:        this.CONNECTION_LINE_1,
            strokeWidth:   this.CONN_STROKE_WIDTH,
            lockMovementX: true,
            lockMovementY: true,
            lockRotation:  true,
            selectable:    true,
            hasControls:   false,
            hasBorders:    false
    };}

    get CONN_STROKE_WIDTH() { return 10;}

    get TITLE_ENABLE_RESPONSIVE() { return "Enable Responsive";}
    get MSG_RESPONSIVE_DENIED() { return "Sorry, your account doesn't have responsive enabled";}

    //Metadata field types
    get FIELD_METADATA_TYPE_GROUP(){ return "group"; }
    get FIELD_METADATA_TYPE_STRING(){ return "string"; }
    get FIELD_METADATA_TYPE_INT(){ return "int"; }
    get FIELD_METADATA_TYPE_BIGINT(){ return "bigint"; }
    get FIELD_METADATA_TYPE_DECIMAL(){ return "decimal"; }
    get FIELD_METADATA_TYPE_BIGDECIMAL(){ return "bigdecimal"; }
    get FIELD_METADATA_TYPE_DATE(){ return "date"; }
    get FIELD_METADATA_TYPE_TIME(){ return "time"; }
    get FIELD_METADATA_TYPE_DATETIME(){ return "int"; }
    get FIELD_METADATA_TYPE_BOOLEAN(){ return "bit"; }
    get FIELD_METADATA_TYPE_ATTACHMENT(){ return "attachment"; }

    //Form control types
    get CONTROL_TYPE_TEXTINPUT() { return "textinput"; }
    get CONTROL_TYPE_TEXTAREA() { return "textarea"; }
    get CONTROL_TYPE_NUMERICINPUT() { return "numericinput"; }
    get CONTROL_TYPE_DATEINPUT() { return "dateinput"; }
    get CONTROL_TYPE_TIMEINPUT() { return "timeinput"; }
    get CONTROL_TYPE_DATE() { return "date"; }
    get CONTROL_TYPE_GROUP() { return "group"; }
    get CONTROL_TYPE_CHECKBOX() { return "tickbox"; }
    get CONTROL_TYPE_RADIOBUTTON() { return "radiobutton"; }
    get CONTROL_TYPE_DROPDOWN() { return "dropdown"; }
    get CONTROL_TYPE_LIST() { return "list"; }
    get CONTROL_TYPE_TIMER() { return "timer"; }
    get CONTROL_TYPE_MASKTEXTINPUT() { return "masktextinput"; }
    get CONTROL_TYPE_NUMERICSTEPPER() { return "numericstepper"; }
    get CONTROL_TYPE_PASSWORDINPUT() { return "passwordinput"; }
    get CONTROL_TYPE_FILEATTACHMENT() { return "fileattachment"; }
    get CONTROL_TYPE_IMAGEIMPORT() { return "imageimport"; }
    get CONTROL_TYPE_VERTICALSLIDER() { return "verticalslider"; }
    get CONTROL_TYPE_HORIZONTALSLIDER() { return "horizontalslider"; }
    get CONTROL_TYPE_SHOWFORMBUTTON() { return "playnewbutton"; }
    get CONTROL_TYPE_WEBSIGNATURE() { return "control_websignature"; }
    get CONTROL_TYPE_WEBSIGNATURESIMPLE() { return "websignature"; }
    get CONTROL_TYPE_RANKING() { return "ranking"; }

    get CONTROL_TYPE_CALENDAR() { return "calendar"; }
    get CONTROL_TYPE_VERTICALSEPARATOR() { return "verticalseparator"; }
    get CONTROL_TYPE_SOUND() { return "sound"; }
    get CONTROL_TYPE_MOVIE() { return "movie"; }
    get CONTROL_TYPE_DATALIST() { return "datalist"; }
    get CONTROL_TYPE_CROSSTAB() { return "crosstab"; }
    get CONTROL_TYPE_GAUGE() { return "gauge"; }

    //Table control types
    get CONTROL_TYPE_TABLE() { return "table"; }
    get CONTROL_TYPE_TABLE_BUTTON() { return "tbl_button"; }
    get CONTROL_TYPE_TABLE_CHECKBOX() { return "tbl_tickbox"; }
    get CONTROL_TYPE_TABLE_CHILDFORMBUTTON() { return "tbl_childFormButton"; }
    get CONTROL_TYPE_TABLE_DATEINPUT() { return "tbl_dateInput"; }
    get CONTROL_TYPE_TABLE_DROPDOWN() { return "tbl_dropDown"; }
    get CONTROL_TYPE_TABLE_FILEATTACHMENT() { return "tbl_fileAttachment"; }
    get CONTROL_TYPE_TABLE_NUMERICINPUT() { return "tbl_numericInput"; }
    get CONTROL_TYPE_TABLE_RADIOBUTTON() { return "tbl_radioButton"; }
    get CONTROL_TYPE_TABLE_TEXTAREA() { return "tbl_textArea"; }
    get CONTROL_TYPE_TABLE_TEXTINPUT() { return "tbl_textInput"; }
    get CONTROL_TYPE_TABLE_TIMEINPUT() { return "tbl_timeInput"; }

    //Regular expressions to fullfil validations
    get REGEX_ONLY_NUMBERS(){ return /^\d+$/; }
    get REGEX_FIND_MAIL_ADDRESS(){ return /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi; }

    get SHORT_LABEL_LEN() { return 8; }

    get WORKFLOW_MARKERS() { return '_edShWfM';}

    // Labels for Settings
    //  - Account Settings section:
    get USER_GROUPS_SETTINGS_TITLE() { return 'General User Group Information'; }

    get RESIZE_PROPERTIES_STYLE_PANEL() { return "resizePropertiesStylePanelEvent"; } 

    // Form / Report details permission settings
    get FORMS_FULL_CONTROL_PERM_DATA_INDEX() { return 4; }
    get FORMS_PERMISSION_ITEM_COUNT() { return 6; }

    get REPORTS_FULL_CONTROL_PERM_DATA_INDEX() { return 3; }
    get REPORTS_PERMISSION_ITEM_COUNT() { return 4; }

    get DASHBOARD_XFER_OWNERSHIP() { return 'transfer-ownership'; }

    // Connection / Action permissions
    get CONNECTION_ACTION_EVERYONE_PERMISSION_ID() { return 910; }

    // Synchronization types
    get SYNCHRONIZATION_USERS_NEW() { return 10; }
    get SYNCHRONIZATION_USERS_CHANGE() { return 20; }
    get SYNCHRONIZATION_USERS_REMOVE() { return 30; }

    get SYNCHRONIZATION_USER_GROUPS_NEW() { return 40; }
    get SYNCHRONIZATION_USER_GROUPS_CHANGE() { return 50; }
    get SYNCHRONIZATION_USER_GROUPS_REMOVE() { return 60; }

    get SYNCHRONIZATION_POSITIONS_NEW() { return 70; }
    get SYNCHRONIZATION_POSITIONS_CHANGE() { return 80; }
    get SYNCHRONIZATION_POSITIONS_REMOVE() { return 90; }

    get WORKFLOW_TABLES_EXPANDED_WIDTH() { return 320;}
    get WORKFLOW_TABLES_COLLAPSED_WIDTH() { return 220;}

    get LAYOUT_TABLES_EXPANDED_WIDTH() { return 355;}
    get LAYOUT_TABLES_COLLAPSED_WIDTH() { return 255;}

    //Dashboard map form versions
    get PROP_MAIN_TABLE_MAP_FORM_VERSIONS_VIEW() {return '#propMapFormVersionsTable'; }

    get TEXT_CONTROLS_KEYS() { return ["control_small_heading", "control_small_text", "control_medium_heading", "control_large_heading", "control_text"]; }
    get BUTTON_CONTROLS_KEYS() { return ["control_button", "control_submit_button", "control_page_button", "control_print_button", "control_play_form_button", "control_play_report_button"]; }
    get GROUPS_CONTROLS_KEYS() { return ["control_checkbox_group", "control_radio_button_group", "control_group"]; }
    get REPORT_CONTROLS_KEYS() { return ["control_data_list", "control_value", "control_pie_chart", "control_filter_selector", "control_line_chart", "control_bar_chart", "control_filter_input", "control_gauge_chart", "control_crosstab", "control_data_grid"]; }

    // Event for refresh Behavior Properties
    get EV_BEHAVIOR_PROPERTY_CHANGED() { return 'behaviorPropertyChanged';}

    //Event for refresh NavPostion Properties
    get EV_NAV_POSITION_PROPERTY_CHANGED() { return 'navPositionPropertyChanged';}

    //Dates constants
    get PROP_DEFAULT_DATE_FORMAT() { return 'MM/DD/YYYY'; }

    get MESSAGE_DASHBOARD_ONMOBILE() {
        return 'The Designer is not available on mobile devices. Please login from a desktop/laptop.';
    }

    get MESSAGE_LOGIN_ONMOBILE() {
        return `Access to the Dashboard may be limited on some mobile devices. 
                If your login is not successful, please login from a desktop/laptop.`;
    }

    get MESSAGE_FLASH_ONMOBILE() {
        return `Access to the Dashboard is currently not supported on this mobile device.
                Please login from a desktop/laptop.`;
    }

    get LENGTH_LINKID(){ return 8; }

    get DASHBOARD_SECTION_APPS() {
        return 'forms';
    }
    get DASHBOARD_SECTION_CONNECTIONS() {
        return 'connections';
    }
    get DASHBOARD_SECTION_REPORTS() {
        return 'reports';
    }
    get DASHBOARD_SECTION_NOTIFICATIONS() {
        return 'notifications';
    }
    get DASHBOARD_SECTION_SETTINGS() {
        return 'settings';
    }

    get LENGTH_LINKID(){ return 8; }

    // PF-3952 URL path name
    get PATH_INCOGNITO() { return ''; }

    get MAX_ITEMS_PER_SECTION_TOOLBAR(){ return this.maxItemOnSlide || 9; }
 
    get MIN_PANEL_LEFT_WIDTH() { return 50; }
    get MIN_PANEL_RIGHT_WIDTH() { return 40; }

    get MAX_PANEL_LEFT_WIDTH() { return this.max_left_width || 420; }
    get MAX_PANEL_RIGHT_WIDTH() { return this.max_right_width || 420; } 

    get DEFAULT_TABLE_WIDTH() { return 171; } 
    get MIN_TABLE_WIDTH() { return 120; } 
    get MIN_COLUMN_WIDTH() { return 50; } 
    get DEFAULT_COLUMN_WIDTH() { return 75; } 
    //Error codes
    get ERROR_CODE_USER_NOT_AUTHENTICATED() { return 2; } 

    get ERROR_CODE_USER_PASSWORD_NOT_RECOGNIZED() { return "1"; }
    get ERROR_MSG_USER_PASSWORD_NOT_RECOGNIZED() { return "Your email and password were not recognized."; }
    get ERROR_MSG_SSO_LOGIN() { return "The SSO feature may not be set up correctly or is not currently active in your installation. Please contact your administrator for assistance."; }
    get ERROR_MSG_SSO_LOGIN_USER_INVALID() { return "The user is inactive or does not exist. Please contact your administrator for assistance."; }
    get ERROR_MSG_SSO_ACCOUNT_DETAILS() { return "The SSO feature does not appear to be enabled on your installation. Please contact your administrator for assistance."; }
    get ERROR_CODE_TEMPORARY_PASSWORD_EXPIRED_OR_INACTVE_USER() { return "24"; }
    get ERROR_MSG_TEMPORARY_PASSWORD_EXPIRED_OR_INACTVE_USER() { return "The password-link has expired. It is only valid for a short time after it has been sent."; }
    get ERROR_CODE_TEMPORARY_PASSWORD_ALREADY_USED() { return "25"; }
    get ERROR_MSG_TEMPORARY_PASSWORD_ALREADY_USED() { return "The password-link is no longer valid. It can only be used once and has already been used."; }
    get ERROR_CODE_LOG_IN_ALLOWED_ONLY_IF_DOMAIN_AUTHENTICATED() { return "58"; }
    get ERROR_MSG_LOG_IN_ALLOWED_ONLY_IF_DOMAIN_AUTHENTICATED() { return "Single Sign-On (SSO) is enabled for your account. Please use your designated SSO URL to log in."; }
    get ERROR_CODE_ACCOUNT_EXPIRED() { return "27"; }
    get ERROR_CODE_TRIAL_ACCOUNT_EXPIRED() { return "213"; }
    get ERROR_MSG_ACCOUNT_EXPIRED() { return "The account you are trying to log into has expired. Please contact your account administrator."; }
    get ERROR_CODE_SYSTEM_EXPIRED() { return "32"; }
    get ERROR_MSG_SYSTEM_EXPIRED() { return "The system has expired."; }
    get ERROR_MSG_ACCOUNT_USER_PASSWORD_NOT_RECOGNIZED() { return "The password is incorrect for the selected account."; }

    get USER_NAME_NOT_DEFINED_TEXT() { return "--No name defined--"; }
    get ITEM_SEARCH_LIMIT_EXCEEDED_TEXT() { return "Only 500 records can be displayed at once using IE. <br/> Please use a modern browser or add more information to the filter criteria."; }

    get PREFIX_STORAGE_USERS_CACHE() { return "___browseAllUsersCache"; }

    //Mobile section
    get OMIT_PAGE() { return "I don't want this page for Mobile."; }
    get ADD_SECTION() { return "Add Section"; }

    get IMPORT_INITIAL_VALUE() { return 'i'; }

    get DIALOG_CANCELED() { return 'dialog_canceled';}

    get SALESFORCE_NAMESPACE() { return 'soap.sforce.com';}

    get SAP_NAMESPACE() { return 'urn:sap-com';}

    get MSG_ELEMENT_REMOVED_FROM_MOBILE() { return 'This element was removed from mobile wizard as well.';}

    get ONE_COLUMN_VIEW_DROPDOWN_TEXT() { return "1 Column"; }
    get TWO_COLUMN_VIEW_DROPDOWN_TEXT() { return "2 Column"; }
    get ZERO_COLUMN_LAYOUT() { return "column0"; }
    get ONE_COLUMN_LAYOUT() { return "column1"; }
    get TWO_COLUMN_LAYOUT() { return "column2"; }
    get COLUMN_ONE_COUNTER_ID() { return "column1-counter"; }
    get COLUMN_TWO_COUNTER_ID() { return "column2-counter"; }
    get COLUMNS_RESET_ID() { return "reset-columns"; }
    get COLUMN_TWO_BADGE_CONTAINER() { return "column2-badge-container"; }
    get COUNTER_RESET_BADGES() { return "counter-reset-badges"; }
    get EMPTY_COLUMN_BADGE() { return "empty-column-badge"; }

    get SET_COLUMNS_TREE() { return 'SetColumnsTree'; }

    get TWO_COLUMNS_ICON() {
        return "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z";
    }

    get EYE_CONTENT_ICON() {
        return "M286.693 391.984l32.579 46.542A333.958 333.958 0 0 1 288 440C168.19 440 63.031 376.051 6.646 280.369a47.999 47.999 0 0 1 0-48.739c24.023-40.766 56.913-75.775 96.024-102.537l57.077 81.539C154.736 224.82 152 240.087 152 256c0 74.736 60.135 135.282 134.693 135.984zm282.661-111.615c-31.667 53.737-78.747 97.46-135.175 125.475l.011.015 41.47 59.2c7.6 10.86 4.96 25.82-5.9 33.42l-13.11 9.18c-10.86 7.6-25.82 4.96-33.42-5.9L100.34 46.94c-7.6-10.86-4.96-25.82 5.9-33.42l13.11-9.18c10.86-7.6 25.82-4.96 33.42 5.9l51.038 72.617C230.68 75.776 258.905 72 288 72c119.81 0 224.969 63.949 281.354 159.631a48.002 48.002 0 0 1 0 48.738zM424 256c0-75.174-60.838-136-136-136-17.939 0-35.056 3.473-50.729 9.772l19.299 27.058c25.869-8.171 55.044-6.163 80.4 7.41h-.03c-23.65 0-42.82 19.17-42.82 42.82 0 23.626 19.147 42.82 42.82 42.82 23.65 0 42.82-19.17 42.82-42.82v-.03c18.462 34.49 16.312 77.914-8.25 110.95v.01l19.314 27.061C411.496 321.2 424 290.074 424 256zM262.014 356.727l-77.53-110.757c-5.014 52.387 29.314 98.354 77.53 110.757z";
    }

    get ADD_OBJECTS_FORM() {
        return "Would you like to add objects to this page?";
    }

    get MOBILE_DIALOG_TITLE() {
        return "Add elements to page";
    }

    get CONTROL_MIN_HEIGHT_16() {
        return 16;
    }

    get CONTROL_MIN_HEIGHT_17() {
        return 17;
    }

    get CONTROL_MIN_HEIGHT_18() {
        return 18;
    }

    get CONTROL_MIN_HEIGHT_15() {
        return 15;
    }

    get CONTROL_MIN_HEIGHT_22() {
        return 22;
    }

    get CONTROL_MIN_HEIGHT_25() {
        return 25;
    }

    get CONTROL_MIN_HEIGHT_27() {
        return 27;
    }

    get CONTROL_MIN_HEIGHT_29() {
        return 29;
    }
    
    get OPEN_AFTER_VIDEO_PLAYED() {
        return 'openWizardAfterVideoPlayed';
    }

    get USER_TYPE_GROUP() {
        return 'group';
    }
    get USER_TYPE_USER() {
        return 'user';
    }
    get USER_TYPE_POSITION() {
        return 'position';
    }

    get NUMERIC_INPUT_MIN_VALUE() {
        return -9999999999999;
    }

    get NUMERIC_INPUT_MAX_VALUE() {
        return 9999999999999;
    }

    get TABLE_NUMERIC_INPUT_MAX_DECIMALS_LENGTH() {
        return 3;
    }

    get DATE_TIME_DEFAULT_VALUE() {
        return  '1970-01-01 12:00:00';
    }

    // Permissions 
    get PERMISSIONS_TABLE_HEIGHT()  { return 130; }

    // 
    get REQUEST_TYPE_CONTENT_TYPE_MAPPING(){
        return [
            { requestType: 'json', contentType: 'application/json' },
            { requestType: 'xml', contentType: 'application/xml' },
            { requestType: 'key', contentType: 'application/x-www-form-urlencoded' },
            { requestType: 'raw', contentType: '' }
        ];
    }

    get BASIC_EMAIL_SERVER_DEFAULTS(){
        return {
            name: 'New Email-Server',
            address: 'smtp.myserver.com',
            port: '25',
            displayName: 'John Smith',
            emailAddress: 'jsmith@mycompany.com',
            replyToDisplayName: '',
            replyToDisplayAddress: '',
            userName: '',
            password: '',
            ssl: false,
            requiresAuthentication: false,
            sendFailureEmail: false,
            failureEmailAddress: '',
            failureEmailFreq: 0,
            smtpTimeout: 1,
            secondEmailServer: -1,
            SecondaryEmailServerID: -1,
            noOfRetry: 1,
            dataType: 'JSON'
        };
    }

    get POPUP_BLOCKER_MESSAGE(){ return "We've detected a popup blocker. Please add the current address to your exception list." }

    // App/Report Statuses
    get PUBLISHED(){ return 'Published'; }
    get UNPUBLISHED(){ return 'Unpublished'; }
    get DRAFT(){ return 'Draft'; }

    //Disabled messages
    get NOT_ADMIN(){ return 'You do not have the required permissions to perform this action.'; }
    get DISABLED_LINK(){ return 'Please publish your App to enable the link.'; }
    get NOT_PUBLISH(){ return ' You do not have permissions to publish this app. Contact your administrator.'; }
    get APP_PUBLISHED(){ return 'This App is already published.'; }
    get DRAFT_REPORT(){ return 'Please publish the report to enable this option.'}
    
    get QUOTE_REQUEST(){ return 'Your request has been sent. You will be contacted shortly by our sales team.'; }

    get TOUR_EMAIL_MAXCHARS(){ return 200; }

    get META_DATA_ACTIONS() {
        return [
            { "@ActionId": "users", "@Name": "Users", "@Type": "usersType" },
            { "@ActionId": "usergroups", "@Name": "User-Groups", "@Type": "usergroupsType" },
            { "@ActionId": "positions", "@Name": "Positions", "@Type": "positionType" }
        ];
    }

    get USER_PARAMETER_SEND() {
        return [
            { "_id": "title", "_name": "Title", "_value": "Title" },
            { "_id": "firstName", "_name": "First Name", "_value": "First Name" },
            { "_id": "lastName", "_name": "Last Name", "_value": "Last Name" },
            { "_id": "fullName", "_name": "Full Name", "_value": "Full Name" },
            { "_id": "email", "_name": "Email", "_value": "Email" },
            { "_id": "isActive", "_name": "is Active", "_value": "is Active" },
            { "_id": "phone", "_name": "Phone", "_value": "Phone" },
            { "_id": "fax", "_name": "Fax", "_value": "Fax" },
            { "_id": "cellphone", "_name": "Cell phone", "_value": "Cell phone" },
            { "_id": "skype", "_name": "Skype", "_value": "Skype" },
            { "_id": "alternateEmail", "_name": "Alternate Email", "_value": "Alternate Email" },
            { "_id": "domainUsername", "_name": "Domain Username", "_value": "Domain Username" },
            { "_id": "customId", "_name": "Custom Id", "_value": "Custom Id" },
            { "_id": "status", "_name": "Role", "_value": "Role" },
            { "_id": "hasOfflineRole", "_name": "Has Offline Role", "_value": "Has Offline Role" },
            { "_id": "address1", "_name": "Address 1", "_value": "Address 1" },
            { "_id": "address2", "_name": "Address 2", "_value": "Address 2" },
            { "_id": "city", "_name": "City", "_value": "City" },
            { "_id": "state", "_name": "State", "_value": "State" },
            { "_id": "zipcode", "_name": "Zip-code", "_value": "Zip-code" },
            { "_id": "country", "_name": "Country", "_value": "Country" },
            { "_id": "userGroupName", "_name": "User-Group Name", "_value": "User-Group Name" },
            { "_id": "userGroupId", "_name": "User-Group ID", "_value": "User-Group ID" },
            { "_id": "positionName", "_name": "Position Name", "_value": "Position Name" },
            { "_id": "positionId", "_name": "Position ID", "_value": "Position ID" }
        ];
    }

    get USER_PARAMETER_RETURN() {
        return [
            { "_id": "title", "_name": "Title", "_value": "Title" },
            { "_id": "firstName", "_name": "First Name", "_value": "First Name" },
            { "_id": "lastName", "_name": "Last Name", "_value": "Last Name" },
            { "_id": "fullName", "_name": "Full Name", "_value": "Full Name" },
            { "_id": "email", "_name": "Email", "_value": "Email" },
            { "_id": "isActive", "_name": "is Active", "_value": "is Active" },
            { "_id": "phone", "_name": "Phone", "_value": "Phone" },
            { "_id": "fax", "_name": "Fax", "_value": "Fax" },
            { "_id": "cellphone", "_name": "Cell phone", "_value": "Cell phone" },
            { "_id": "skype", "_name": "Skype", "_value": "Skype" },
            { "_id": "alternateEmail", "_name": "Alternate Email", "_value": "Alternate Email" },
            { "_id": "domainUsername", "_name": "Domain Username", "_value": "Domain Username" },
            { "_id": "customId", "_name": "Custom Id", "_value": "Custom Id" },
            { "_id": "status", "_name": "Role", "_value": "Role" },
            { "_id": "hasOfflineRole", "_name": "Has Offline Role", "_value": "Has Offline Role" },
            { "_id": "address1", "_name": "Address 1", "_value": "Address 1" },
            { "_id": "address2", "_name": "Address 2", "_value": "Address 2" },
            { "_id": "city", "_name": "City", "_value": "City" },
            { "_id": "state", "_name": "State", "_value": "State" },
            { "_id": "zipcode", "_name": "Zip-code", "_value": "Zip-code" },
            { "_id": "country", "_name": "Country", "_value": "Country" },
            { "_id": "userId", "_name": "User Id", "_value": "User Id" }
        ];
    }

    get META_USERS_PARAMETERS(){
        return {
            "returnParameters": this.USER_PARAMETER_RETURN, 
            "sendParameters":this.USER_PARAMETER_SEND
        }
    };

    get META_POSITIONS_PARAMETERS() {
        return {
            "returnParameters": [{ "_id": "name", "_name": "Name", "_value": "Name" },
            { "_id": "positionId", "_name": "Position ID", "_value": "Position ID" },
            { "_id": "membersNo", "_name": "Number of Members", "_value": "Number of Members" }],
            "sendParameters": [{ "_id": "name", "_name": "Name", "_value": "Name" },
            { "_id": "userId", "_name": "User Id", "_value": "User Id" }]
        }
    };
    
    get META_USER_GROUPS_PARAMETERS() {
        return {
            "returnParameters": [{ "_id": "name", "_name": "Name", "_value": "Name" },
            { "_id": "userGroupId", "_name": "User-Group ID", "_value": "User-Group ID" },
            { "_id": "membersNo", "_name": "Number of Members", "_value": "Number of Members" }],
            "sendParameters": [{ "_id": "name", "_name": "Name", "_value": "Name" },
            { "_id": "userId", "_name": "User Id", "_value": "User Id" }]
        }
    };
}

// A singleton. Exports instance, not the class.
const constants = new Constants;
export default constants;
